import React from "react";
import { Link } from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";
import PhoneMockup from "../components/phoneMockup";

const Hero = () => {
  return (
    <section className="bg-cloud">
      <div className="max-w-content mx-auto grid grid-cols-1 items-center gap-10 px-6 py-10 lg:grid-cols-[1.15fr_0.85fr] lg:gap-12 lg:px-10 lg:py-14">
        <div>
          <span className="inline-flex items-center rounded-full bg-gold-soft px-3 py-1 text-xs font-semibold text-gold">
            ONDC network partner
          </span>
          <h1 className="mt-4 text-3xl font-bold leading-[1.15] text-brand sm:text-4xl lg:text-[2.75rem]">
            One platform for planning events, start to finish.
          </h1>
          <p className="mt-4 max-w-prose text-base text-muted lg:text-lg">
            We're launching with birthdays: tell us the date, guest count,
            and budget, and we curate decor, cakes, and catering from our
            network of verified partners — one clear quote, delivered
            straight to you. Weddings, corporate events, and more are next.
          </p>

          <div className="mt-6 flex flex-col gap-3 sm:flex-row">
            <Link
              to="/book"
              className="inline-flex items-center justify-center gap-2 rounded-full bg-action px-6 py-3 text-base font-medium text-paper hover:bg-action/90 transition-colors"
            >
              Get your free quote
              <FiArrowRight />
            </Link>
            <Link
              to="/packages"
              className="inline-flex items-center justify-center rounded-full border border-line px-6 py-3 text-base font-medium text-brand hover:border-brand transition-colors"
            >
              See birthday packages
            </Link>
          </div>

          <div className="mt-6 flex flex-wrap gap-x-6 gap-y-2 border-t border-line pt-4 text-sm text-muted">
            <span>Verified service partners</span>
            <span>One per-guest price</span>
            <span>Delivered on schedule</span>
          </div>
        </div>

        <div className="flex flex-col items-center gap-2">
          <PhoneMockup compact />
          <Link to="/about" className="text-xs font-medium text-action hover:underline">
            More about the app →
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Hero;
